<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative text-center">
      <div class="text-center">{{ message }}</div>

      <label class="mt-6 text-xs text-content-400 text-left w-full" for="notes">{{
        notesLabel
      }}</label>
      <textarea class="h-28 mt-1" id="notes" type="text" v-model="notes" />

      <primary-button class="mt-4" :loading="loading" @buttonClicked="confirm"
        >Confirmar
      </primary-button>

      <button
        v-if="!loading"
        class="mt-4 mx-auto w-full system-button"
        @click.prevent="close"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notes: "",
    };
  },

  props: {
    loading: false,
    message: String,
    notesLabel: {
      type: String,
      default: "Comentarios (opcional)",
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    confirm() {
      this.$emit("confirm", this.notes);
    },
  },
};
</script>
